// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AddItemsFromExistingTemplateQueryVariables = Types.Exact<{
  templateId: Types.Scalars['ID']['input'];
}>;


export type AddItemsFromExistingTemplateQuery = { __typename?: 'Query', itemTemplate: { __typename?: 'ItemTemplate', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, displayName: string, shortName?: string | null | undefined, active: boolean, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean, isExteriorPalette: boolean, isSpecLevel: boolean }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string } }> } | null | undefined } };

export type AddItemsFromExistingTemplateRpoFragment = { __typename?: 'ReadyPlanOption', id: string, name: string, displayName: string, shortName?: string | null | undefined, active: boolean, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean, isExteriorPalette: boolean, isSpecLevel: boolean }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string } };

export const AddItemsFromExistingTemplateRpoFragmentDoc = gql`
    fragment AddItemsFromExistingTemplateRPO on ReadyPlanOption {
  id
  name
  displayName
  shortName
  active
  type {
    id
    isElevation
    isExteriorPalette
    isSpecLevel
  }
  location {
    id
    name
  }
  globalOption {
    id
  }
}
    `;
export const AddItemsFromExistingTemplateDocument = gql`
    query AddItemsFromExistingTemplate($templateId: ID!) {
  itemTemplate(id: $templateId) {
    id
    readyPlan {
      id
      options {
        ...AddItemsFromExistingTemplateRPO
      }
    }
  }
}
    ${AddItemsFromExistingTemplateRpoFragmentDoc}`;

/**
 * __useAddItemsFromExistingTemplateQuery__
 *
 * To run a query within a React component, call `useAddItemsFromExistingTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddItemsFromExistingTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddItemsFromExistingTemplateQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useAddItemsFromExistingTemplateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddItemsFromExistingTemplateQuery, AddItemsFromExistingTemplateQueryVariables> & ({ variables: AddItemsFromExistingTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddItemsFromExistingTemplateQuery, AddItemsFromExistingTemplateQueryVariables>(AddItemsFromExistingTemplateDocument, options);
      }
export function useAddItemsFromExistingTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddItemsFromExistingTemplateQuery, AddItemsFromExistingTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddItemsFromExistingTemplateQuery, AddItemsFromExistingTemplateQueryVariables>(AddItemsFromExistingTemplateDocument, options);
        }
// @ts-ignore
export function useAddItemsFromExistingTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AddItemsFromExistingTemplateQuery, AddItemsFromExistingTemplateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddItemsFromExistingTemplateQuery, AddItemsFromExistingTemplateQueryVariables>;
export function useAddItemsFromExistingTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddItemsFromExistingTemplateQuery, AddItemsFromExistingTemplateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddItemsFromExistingTemplateQuery | undefined, AddItemsFromExistingTemplateQueryVariables>;
export function useAddItemsFromExistingTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddItemsFromExistingTemplateQuery, AddItemsFromExistingTemplateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddItemsFromExistingTemplateQuery, AddItemsFromExistingTemplateQueryVariables>(AddItemsFromExistingTemplateDocument, options);
        }
export type AddItemsFromExistingTemplateQueryHookResult = ReturnType<typeof useAddItemsFromExistingTemplateQuery>;
export type AddItemsFromExistingTemplateLazyQueryHookResult = ReturnType<typeof useAddItemsFromExistingTemplateLazyQuery>;
export type AddItemsFromExistingTemplateSuspenseQueryHookResult = ReturnType<typeof useAddItemsFromExistingTemplateSuspenseQuery>;
export type AddItemsFromExistingTemplateQueryResult = ApolloReactCommon.QueryResult<AddItemsFromExistingTemplateQuery, AddItemsFromExistingTemplateQueryVariables>;